// src/theme/GlobalStyles.jsx or GlobalStyles.tsx
import React from 'react';


export const globalStyles = {
  html: { height: '100%' },
  body: { margin: 0, padding: 0, height: '100%', backgroundColor: '#f5f5f5' },
  '#root': { height: '100%' }
};

export default globalStyles;
